import { SpectateActions } from "../constants";
import { Packet, PacketType } from "./packet";

export type SpectateData = {
    readonly type: PacketType.Spectate
} & (
    | {
        readonly spectateAction: SpectateActions.SpectateSpecific
        readonly playerID: number
    }
    | {
        /** a report: who (default: whoever you're watching), what for (see definitions/reports.ts), and details */
        readonly spectateAction: SpectateActions.Report
        readonly playerID?: number
        readonly reportCategory?: number
        readonly reportText?: string
    }
    | {
        readonly spectateAction: Exclude<SpectateActions, SpectateActions.SpectateSpecific | SpectateActions.Report>
        readonly playerID?: undefined
    }
);

/** the report details on the wire (UTF-8, up to twice the character limit) */
const REPORT_TEXT_BYTES = 600;

export const SpectatePacket = new Packet<SpectateData>(PacketType.Spectate, {
    serialize(stream, data) {
        stream.writeUint8(data.spectateAction);

        if (data.spectateAction === SpectateActions.SpectateSpecific) {
            stream.writeObjectId(data.playerID);
        } else if (data.spectateAction === SpectateActions.Report) {
            stream.writeBooleanGroup(data.playerID !== undefined);
            if (data.playerID !== undefined) stream.writeObjectId(data.playerID);
            stream.writeUint8(data.reportCategory ?? 0);
            stream.writeString(REPORT_TEXT_BYTES, data.reportText ?? "");
        }
    },

    deserialize(stream, data) {
        data.spectateAction = stream.readUint8();

        if (data.spectateAction === SpectateActions.SpectateSpecific) {
            data.playerID = stream.readObjectId();
        } else if (data.spectateAction === SpectateActions.Report) {
            const report = data as { playerID?: number, reportCategory?: number, reportText?: string };
            const [hasTarget] = stream.readBooleanGroup();
            if (hasTarget) report.playerID = stream.readObjectId();
            report.reportCategory = stream.readUint8();
            report.reportText = stream.readString(REPORT_TEXT_BYTES);
        }
    }
});
